import React, { useEffect } from 'react';
import {
  useRouteMatch,
  useHistory,
  useLocation,
  Switch,
  Route,
} from 'react-router-dom';

import { generateSafeUrl } from '../../utils';

import PageTransition from '../common/PageTransition/PageTransition';

import { FunnelStepPropTypes } from '../common/types';

import { SUBSTEP_ROUTES } from './routes';
import { HasSpecialistReferral } from './substeps/HasSpecialistReferral';
import { ConfirmNoReferral } from './substeps/ConfirmNoReferral';

const ReferralParent = ({ position, moveToNextStep }) => {
  const history = useHistory();
  const location = useLocation();
  const { url } = useRouteMatch();
  const safeUrl = generateSafeUrl(url);

  const goToConfirmSubstep = () => {
    setSubStep(SUBSTEP_ROUTES.CONFIRM_NO_REFERRAL);
  };

  useEffect(() => {
    // If the user ends up on the main reason details page, redirect them to the main substep
    if (location.pathname === safeUrl) {
      setSubStep(SUBSTEP_ROUTES.HAS_REFERRAL, true);
    }
  }, [location]);

  const setSubStep = (subStep, shouldReplace) => {
    const subRouteFullPath = subStep ? `${safeUrl}${subStep.path}/` : safeUrl;

    if (history.location.pathname !== subRouteFullPath) {
      const updateHistory = shouldReplace ? history.replace : history.push;
      updateHistory(subRouteFullPath);
    }
  };

  return (
    <PageTransition id={location.pathname.split('/')[3]}>
      <Switch location={location}>
        <Route
          path={`${safeUrl}${SUBSTEP_ROUTES.HAS_REFERRAL.path}`}
          render={() => (
            <HasSpecialistReferral
              moveToNextStep={moveToNextStep}
              goToConfirmSubstep={goToConfirmSubstep}
              position={position}
            />
          )}
        />
        <Route
          path={`${safeUrl}${SUBSTEP_ROUTES.CONFIRM_NO_REFERRAL.path}`}
          render={() => (
            <ConfirmNoReferral
              moveToNextStep={moveToNextStep}
              position={position}
            />
          )}
        />
      </Switch>
    </PageTransition>
  );
};

ReferralParent.propTypes = FunnelStepPropTypes;

export default ReferralParent;
